import { AddClientProps } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function addClient(affiliateFirmId: string, body: AddClientProps) {
  const response = await fetcher(`affiliate-firms/${affiliateFirmId}/clients`, {
    method: 'POST',
    body,
  });

  return response;
}
